import { ReportHandler } from 'web-vitals';

// Lazy-imports web-vitals so the metric collector itself doesn't sit in the
// main bundle. Called from index.tsx AFTER Sentry has loaded (so reported
// metrics flow into Sentry breadcrumbs); also safe to call standalone with
// any handler (e.g., console.log) for ad-hoc local profiling.
const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
